import _ from 'lodash'

const numeral = require('numeral')
import Vue from 'vue'

window.get_host = 'http://localhost:8080/'
Vue.config.productionTip = false

const vm = new Vue({
    el: '#app',
    data() {
        return {
            config: window.topic.config,
            req: {
                gender: 'male',
                gender_short: "M",
                age: '',
                premium: '',
                period: _.first(window.topic.config.period),
                times: '',
            },
            error: {
                age: false,
                premium: false,
                times: false,
            },
            result: {
                base_num: 0,
                discount: 0,
                year_premium: 0,
                year_discount_premium: 0,
                next_year_discount_premium: 0,
                total_premium: 0,
                expired: 0,
                cancel_fee_rate: null,
                times_fee_rate: null,
                year_fee: 0,
                year_fee_rate: 0,
                remuneration: 0,
            },
            clickName: '立即試算'
        }
    },

    mounted() {

    },
    watch: {
        "req.gender": function (val) {
            let gender_short = 'M'
            if (val === 'female') {
                gender_short = 'F'
            }
            this.$set(this.req, 'gender_short', gender_short)
        },
        "req.age": function (val) {
            this.$set(this.error, 'age', val === '')
            if (val < this.config.age.min) {
                val = this.config.age.min
            } else if (val > this.config.age.max) {
                val = this.config.age.max
            }
            this.$set(this.req, 'age', val)
        },
        "req.premium": function (val) {
            this.$set(this.error, 'premium', val === '')
            this.checkPremium()


        },
        "req.period": function (val) {
            this.checkPremium()
        },
        "req.times": function (val) {
            this.$set(this.error, 'times', val === '')
            if (val < this.config.times.min) {
                val = this.config.times.min
            } else if (val > this.config.times.max) {
                val = this.config.times.max
            }
            this.$set(this.req, 'times', val)
        }
    },
    filters: {
        money(val, hasM = true) {
            let m = hasM ? '$' : ''

            return `${m}${numeral(val).format('0,0.0')}`
        },
        money2(val) {
            return numeral(val).format('0,0')
        },
        percentage(val) {
            return numeral(val * 100).format('0.0[0]')
        }
    },
    methods: {
        checkPremium() {
            let val = this.req.premium

            let premium_role = _.find(this.config.premium, (o, k) => {
                return k === parseInt(this.req.period)
            })
            if (this.config.premium.hasOwnProperty(parseInt(this.req.period))) {
                premium_role = this.config.premium[this.req.period]
            }

            if (!premium_role) {
                return
            }

            const {min, max} = premium_role

            if (val < min) {
                val = min
            } else if (val > max) {
                val = max
            }
            this.$set(this.req, 'premium', val)
        },
        yearDiscountPremium(val) {

            let res = val * this.result.year_discount_premium
            if (res > this.result.total_premium) {
                res = this.result.total_premium
            }
            return res
        },
        cancelFee(val) {
            return val * this.result.base_num
        },
        getYearFee(times,) {
            return  (this.result.times_fee_rate[times] *  this.result.base_num).toFixed(0)
        },
        getYearFeeRate(times) {
            return (this.getYearFee(times) / this.yearDiscountPremium(times))
        },
        showSWAlert() {
            swal({
                title: '小提醒',
                text: '抱歉！沒有適合的商品喔',
                type: "warning",
                confirmButtonText: "確認"
            }, function () {
                swal.close();
            });
        },
        onClick() {
            const vm = this
            let check = true
            if (this.req.age === '') {
                this.error.age = true
                check = false
            }
            if (this.req.premium === '') {
                this.error.premium = true
                check = false
            }
            if (this.req.times === '') {
                this.error.times = true
                check = false
            }
            if (!check) {
                return
            }
            console.log(vm.req)
            //取得基數模組
            let baseModel = _.find(vm.config.base, o => {
                return o.period === vm.req.period
                    && o.age === vm.req.age
                    && o.gender === vm.req.gender_short
            })
            console.log(baseModel)
            if (!baseModel) {
                $(".countResult").slideUp(500);
                $(".countListResult").slideUp(500);
                return;
            }
            //基數
            let baseNum = (vm.req.premium / baseModel.rate).toFixed(0)
            console.log(baseModel)
            console.log(baseNum)
            vm.result.base_num = baseNum
            //取得折扣模組
            let discountModel = _.find(vm.config.discount, o => {
                return o.period === vm.req.period
                    && o.base.min <= baseNum
                    && o.base.max >= baseNum
            })

            console.log(discountModel)

            if (!discountModel) {
                $(".countResult").slideUp(500);
                $(".countListResult").slideUp(500);
                return;
            }
            //取得解約金費率
            let cancel_feeModel = _.find(vm.config.cancel_fee, o => {
                return o.period === vm.req.period
                    && o.age === vm.req.age
                    && o.gender === vm.req.gender_short
            })

            if (!cancel_feeModel) {
                $(".countResult").slideUp(500);
                $(".countListResult").slideUp(500);
                return;
            }
            vm.result.cancel_fee_rate = cancel_feeModel.rate
            console.log(cancel_feeModel)


            //取得年領回金
            let times_feeModel = _.find(vm.config.times_fee, o => {
                return o.period === vm.req.period
                    && o.age === vm.req.age
                    && o.gender === vm.req.gender_short
            })
            if (!times_feeModel) {
                $(".countResult").slideUp(500);
                $(".countListResult").slideUp(500);
                return;
            }
            console.log(times_feeModel)
            vm.result.times_fee_rate = times_feeModel.rate

            //年繳保費
            vm.result.year_premium = baseModel.rate * baseNum
            //保費折扣
            vm.result.discount = discountModel.discount
            //折扣後保費
            vm.result.year_discount_premium = (vm.result.year_premium * (1 - vm.result.discount)).toFixed(0)
            console.log(vm.result.year_premium)
            //續年保費
            vm.result.next_year_discount_premium = (vm.result.year_premium * (1 - vm.result.discount)).toFixed(0)
            //總繳金額
            vm.result.total_premium = vm.result.year_discount_premium * vm.req.period

            //確認年期資料
            let checkTimes = true
            if (vm.req.times > cancel_feeModel.rate.length) {

                checkTimes = false
            }

            if (cancel_feeModel.rate[vm.req.times] === 0) {
                checkTimes = false
            }

            if (!checkTimes) {
                $(".countResult").slideUp(500);
                $(".countListResult").slideUp(500);
                vm.showSWAlert()
                return;
            }

            //領回金額

            vm.result.expired = cancel_feeModel.rate[vm.req.times] * baseNum

            //確認領回年金
            let checkTimesFee = true
            if (vm.req.times > times_feeModel.rate.length) {

                checkTimesFee = false
            }

            if (times_feeModel.rate[vm.req.times] === 0) {
                checkTimesFee = false
            }
            if (!checkTimesFee) {
                $(".countResult").slideUp(500);
                $(".countListResult").slideUp(500);
                vm.showSWAlert()
                return;
            }
            console.log(times_feeModel.rate[vm.req.times])

            //年配息
            vm.result.year_fee = this.getYearFee(vm.req.times)

            //年配息率
            vm.result.year_fee_rate = this.getYearFeeRate(vm.req.times, vm.result.year_discount_premium)

            $(".countResult").slideDown(500);
            vm.clickName = '重新計算'
        }
    }
})